import { createContext, useContext, type ReactNode } from "react";
import type { MonitoramentoGruposGateway } from "../infrastructure/monitoramento-grupos.gateway";

const Contexto = createContext<MonitoramentoGruposGateway | null>(null);

export function ProvedorDeMonitoramentoGrupos({
  gateway,
  children,
}: {
  readonly gateway: MonitoramentoGruposGateway;
  readonly children: ReactNode;
}) {
  return <Contexto.Provider value={gateway}>{children}</Contexto.Provider>;
}

export function useMonitoramentoGruposGateway(): MonitoramentoGruposGateway {
  const gateway = useContext(Contexto);
  if (!gateway) {
    throw new Error(
      "useMonitoramentoGruposGateway fora do ProvedorDeMonitoramentoGrupos",
    );
  }
  return gateway;
}
